import React from 'react';
import FieldDescription from './FieldDescription';
import {maskSecret} from '../utils/dataFunctions';

const styles = {
    container: {lineHeight: 1.4},
    label: {display: 'block', fontSize: 13, color: 'rgba(0, 0, 0, 0.54)', letterSpacing: '-0.015em'},
    field: {display: 'block', backgroundColor: '#fafafa', fontSize: 16, margin: '0 0 8px 0', padding: '8px 0 4px 0'},
    name: {fontWeight: 600}
};

/**
 * A component for displaying External Store Integration Details from a record
 *
 * @param record
 * @return {JSX.Element}
 * @constructor
 */
const TitleStoreIntegrationDetails = ({record}) => {

    const setShopifyIntegrationRows = () => {
        const list = record.integrations ?? [];
        return list.map((item, idx) => {
            const emails = (item.store_metadata.email_addresses) ? item.store_metadata.email_addresses.join(', ') : '';
            return (
                <span key={`title-integration-${idx}`}>
                    <span style={styles.label}>Billing Reference</span>
                    <span style={styles.field}>{item.store_metadata.billing_reference_desc}</span>
                    <span style={styles.label}>Store App URL</span>
                    <span style={styles.field}>{item.store_metadata.store_url}</span>
                    <span style={styles.label}>Store App Client ID</span>
                    <span style={styles.field}>{item.store_metadata.store_app_client_id}</span>
                    <span style={styles.label}>Store App Secret</span>
                    <span style={styles.field}>{maskSecret(item.store_metadata.store_app_secret)}</span>
                    <span style={styles.label}>Notification Emails</span>
                    <span style={styles.field}>{emails}</span>

                </span>

            )
        });
    };

    if (!record?.integrations?.length) {
        return (
            <>
            </>
        );
    }

    return (
        <div style={styles.container}>
            <FieldDescription
                text={`External Store Integration (${record.store_type})`}
                header={true} marginBottom={true}/>
            <FieldDescription
                description={true}
                marginBottom={true}
                text={`The fields below are derived from an application installed on ${record.store_type}.`}
            />
            {record.store_type === 'Shopify' &&
                <>
                    {[...setShopifyIntegrationRows()]}
                </>
            }
        </div>
    );
};

export default TitleStoreIntegrationDetails;
